module.exports = __webpack_public_path__ + "media/images/HighFive-237802c2.svg";